import React from 'react';
import { branch, renderNothing } from 'recompose';
import Media from 'react-media';
import {
  Container,
  ImageContainer,
  ArticleDetailContent,
  ArticleDetailTable,
  InnerContainer,
} from './style';
import { NavToggle } from '../toggle';
import QuantityManipulator from '../../containers/quantitymanipulator';
import Price from '../../containers/price';
import { Heading, Text, FlexRow } from '../misc';
import Image from '../image';

const hideIfNoData = hasNoData => branch(hasNoData, renderNothing);
const enhance = hideIfNoData(props => !props.articleID);
const keyExists = (obj, key) => {
  if (obj && obj[key]) return <td>{obj[key]}</td>;
  else return <td>-</td>;
};

const ArticleDetail = enhance(
  ({
    articleID,
    brand,
    segment,
    material,
    frameType,
    color,
    prices,
    bridgeWidth,
    lensWidth,
    onClose,
    memo,
  }) => (
    <Container id="article-detail-outer-container">
      <InnerContainer id="article-detail-inner-container">
        <NavToggle onClick={onClose} isExpanded />
        <ImageContainer>
          <Media query="(min-width: 40rem)">
            {matches => (
              <Image
                aspectRatio={matches ? 344 : 177}
                src={`${
                  process.env.REACT_APP_BASE_IMAGE_PATH_LARGE
                }${articleID}.jpg`}
              />
            )}
          </Media>
        </ImageContainer>
        <ArticleDetailContent>
          <FlexRow style={{ paddingBottom: '8px' }}>
            <div
              css={`
                display: block;
              `}
            >
              <Heading>{articleID}</Heading>
              <Text style={{ paddingTop: '4px' }}>{brand}</Text>
            </div>
            <Price prices={prices} />
          </FlexRow>
          <ArticleDetailTable>
            <tbody>
              {segment && segment.de && (
                <tr>
                  <td>Segment: </td>
                  {keyExists(segment, 'de')}
                </tr>
              )}
              {material.label && material.label.de && (
                <tr>
                  <td>Material: </td>
                  {keyExists(material.label, 'de')}
                </tr>
              )}
              {frameType && frameType.de && (
                <tr>
                  <td>Fassungstyp: </td>
                  {keyExists(frameType, 'de')}
                </tr>
              )}
              {color.label && color.label.de && (
                <tr>
                  <td>Farbe: </td>
                  {keyExists(color.label, 'de')}
                </tr>
              )}
              {bridgeWidth ? (
                <tr>
                  <td>Stegweite:</td>
                  <td>{bridgeWidth} mm</td>
                </tr>
              ) : null}
              {lensWidth ? (
                <tr>
                  <td>Scheibengröße:</td>
                  <td>{lensWidth} mm</td>
                </tr>
              ) : null}
              {memo && (
                <tr>
                  <td>Artikelinformation: </td>
                  <td>{memo}</td>
                </tr>
              )}
            </tbody>
          </ArticleDetailTable>
          <FlexRow
            css={`
              width: 100%;
              padding: 8px;
            `}
          >
            <QuantityManipulator articleID={articleID} />
          </FlexRow>
        </ArticleDetailContent>
      </InnerContainer>
    </Container>
  )
);

export default ArticleDetail;



// WEBPACK FOOTER //
// ./src/components/articledetail/index.js